<template>
  <div class="progress-bar-container" :style="containerStyle">
    <div class="progress-bar-inner" :style="innerStyle"></div>
    <span class="progress-bar-span">{{ progress }}%</span>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: '100%',
    },
    progress: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    containerStyle() {
      return {
        width: this.width,
        height: this.height,
      }
    },
    innerStyle() {
      return {
        width: `${this.progress}%`,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.progress-bar-container {
  background-color: grey;
  border-radius: 0.125em;
  margin-bottom: 1em;
  line-height: 1.125;
  position: relative;
  height: 2em;
}

.progress-bar-inner {
  background-color: $color-primary;
  height: 100%;
  position: absolute;
  z-index: z-index(progress-bar-container);
}

.progress-bar-span {
  height: 100%;
  position: absolute;
  z-index: z-index(progress-bar-inner);
  width: 100%;
  text-align: center;
  align-content: center;
}
</style>
